module.exports = __webpack_public_path__ + "img/mono-square.6fdf62cc.svg";